import React from "react";
import { useContext } from "react";
import { ContextGridCxC } from "..";

export const BalancePending = () => {
  const { element } = useContext(ContextGridCxC);

  return element.newResidue.text;
};
